/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import styled from 'styled-components';
import PageCard from './page-card';
import PageCardStyles from './page-card-styles';

export default styled(PageCard)`${PageCardStyles}`;
